import { api } from "@/lib/api";

// Cached fetch of the global, owner-managed tag list (GET /api/tags).
// Used by the post editor, the public submission modal, and anywhere
// else that needs the current set of selectable tags.
let cache = null;
let pending = null;

const FALLBACK = ["events", "food", "grocery", "beaches", "retreats", "clubs"];

export function fetchTags(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (!pending || force) {
    pending = api
      .get("/tags")
      .then((r) => {
        cache = Array.isArray(r.data?.tags) && r.data.tags.length ? r.data.tags : FALLBACK;
        return cache;
      })
      .catch(() => {
        cache = FALLBACK;
        return cache;
      })
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}

export function clearTagsCache() {
  cache = null;
}
